<!------------------------------

    Table Wrapper

------------------------------->


<sb-table-wrapper headline="{{'lang.headlines.areas' | translate}}" [itemsData]="areas"
                  [options]="options" (optionsChange)="requestDebounced($event)" [loading]="loading"
                  [itemName]="'areas'"
                  [showExactMatch]="true" [isInIntegratedContext]="true">


  <!------------------------------

    Header More

------------------------------->
  <div header-more>
    <sb-button ngbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top" container="body"
               classes="btn-default actionButtonMinWidth"
               (click)="requestDebounced()" [disabled]="loading" [loading]="loading">
      <sb-icon icon="refresh"></sb-icon>
    </sb-button>
    <a *ngPermissions="permissionService.Permission.area_list"
       [sbRouterLink]="util.RoutingID.areas" [queryParams]="{'company': companyId}">
      <button class="btn btn-primary">{{ 'lang.globals.showInList' | translate }}</button>
    </a>
  </div>
  <!------------------------------

     Table Header

------------------------------->
  <ng-template #thead>
    <tr>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.areas.address' | translate }}
      </th>
      <th>
        {{ 'lang.globals.category' | translate }}
      </th>
      <th>
        {{ 'lang.globals.modifiedAt' | translate }}
      </th>
    </tr>
  </ng-template>

  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-area>
    <tr>
      <td>
        <sb-comp-name-wrapper>
          <a firstLine *ngIf="area.polygons && area.polygons.length > 0" class="link" ngbTooltip
             [sbMapTooltip]="{type: 'Polygon', data: util.geo.polygonDTOArrayToPolygonArray(area.polygons)}"
             tooltipClass="widthFix" placement="right left" container="body"
             openDelay="300">
            <sb-icon icon="location" class="mr-2"></sb-icon>
            <sb-value-definition
              [text]="(area.name) || area.name === '' ? area.name : 'n. def.'">
            </sb-value-definition>
          </a>
          <span firstLine *ngIf="!(area.polygons && area.polygons.length > 0)">
            <sb-value-definition
              [text]="(area.name) || area.name === '' ? area.name : 'n. def.'">
            </sb-value-definition>
          </span>
        </sb-comp-name-wrapper>
      </td>
      <td>
        <a *ngIf="area?.address?.position" class="link" ngbTooltip
           [sbMapTooltip]="{type: 'Coordinates', data: { x: area.address.position.coordinates[0], y: area.address.position.coordinates[1] }}"
           tooltipClass="widthFix" placement="right left" container="body" openDelay="300">
          <sb-icon icon="location" class="mr-2"></sb-icon>
          {{ stringTransformation.addressToString(area.address) }}
        </a>
        <span *ngIf="!area?.address?.position"> {{ stringTransformation.addressToString(area.address) }}</span>
      </td>
      <td>
        {{ area.category?.name }}
      </td>
      <td>
        <sb-comp-display-modified [data]="area"></sb-comp-display-modified>
      </td>
    </tr>
  </ng-template>
</sb-table-wrapper>
